<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { useVuelidate } from "@vuelidate/core";
import { useValidators } from "@/composables/useValidators";
import CnmcFieldErrors from "./CnmcFieldErrors.vue";

const props = withDefaults(
  defineProps<{
    label: string;
    submitLabel: string;
    disabled?: boolean;
    buttonClass?: string;
  }>(),
  { buttonClass: "btn-outline-primary" }
);
const emit = defineEmits<{ submit: [reason: string] }>();
const { t } = useI18n();
const validators = useValidators(t);
const reason = ref("");
const v$ = useVuelidate(
  {
    reason: {
      required: validators.required,
      minLength: validators.minLength(5),
      maxLength: validators.maxLength(2000),
    },
  },
  { reason },
  { $autoDirty: true, $stopPropagation: true }
);
const submit = () => {
  v$.value.$touch();
  if (!props.disabled && !v$.value.$invalid) emit("submit", reason.value);
};
</script>

<template>
  <form class="d-flex flex-wrap gap-2" novalidate @submit.prevent="submit">
    <input
      v-model.trim="reason"
      :placeholder="label"
      :aria-label="label"
      class="form-control"
      :class="{ 'is-invalid': v$.reason.$error }"
      :aria-invalid="v$.reason.$error"
      :disabled
      @blur="v$.reason.$touch()"
    />
    <CnmcFieldErrors :validation="v$.reason" />
    <button class="btn btn-sm" :class="buttonClass" :disabled>
      {{ submitLabel }}
    </button>
  </form>
</template>
